import script from "./CampaignPromotion.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignPromotion.vue?vue&type=script&setup=true&lang=js"

import "./CampaignPromotion.vue?vue&type=style&index=0&id=eeaccbd4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeaccbd4"]])

export default __exports__